export const GLOBAL = {
    backgroundColor: 'rgba(206, 163, 179, 0.6)',
}

export const HEADER = {
    height: 70, // header高度
    backgroundColor: '#242734', // header背景色
}

export const FOOTER = {
    backgroundColor: 'rgba(0, 0, 0, 0.85)'
}
